import api from "./api";

export async function getVestibularConfig() {
  const response = await api.get("/vestibulares");
  return response?.data?.data || null;
}

export async function uploadVestibularHtml(file) {
  const payload = new FormData();
  payload.append("file", file);

  const response = await api.post("/vestibulares", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data?.data || null;
}

export async function uploadVestibularAttachment(file) {
  const payload = new FormData();
  payload.append("file", file);

  const response = await api.post("/vestibulares/arquivo", payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response?.data?.data?.url || null;
}
